<template>
    <div :class="type === 'mobile' ? 'search-mobile__wrapper' : 'search__wrapper'">
        <template v-if="type === 'desktop'">
            <div class="search__input-wrapper">
                <span class="search__input-inner">
                    <input type="search"
                           class="search__input js--width__dynamic"
                           title="search desktop"
                           @input="autocomplete($event.target.value)"
                           @keyup.enter="prepareSearch()"
                           @keyup.down="keydown()"
                           @keyup.up="keyup()"
                           @focus="setIsSearchFocused(true)"
                           @blur="setIsSearchFocused(false)"
                           :placeholder="$translate('ODNaPo::NaPo.searchDesktopPlaceholder')">
                    <button class="search__button"
                            @click="search()">
                        <svg width="20" height="20">
                            <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                 xlink:href="#svg-search">
                            </use>
                        </svg>
                    </button>
                </span>
            </div>
            <div class="search__desktop-result-wrapper js--search__result">
                <transition name="fade">
                    <div v-if="autocompleteResult.length">
                        <div class="search__count">
                            {{ $translate("ODNaPo::NaPo.searchCount") }} &nbsp;({{ total }})
                        </div>
                        <div class="search__result-container">
                            <div class="search__result-wrapper"
                                 v-for="(item, index) in autocompleteResult"
                                 :key="index"
                                 @click="selectAutocompleteItem(item)"
                                 :class="{ 'autocomplete-selected': selectedAutocompleteIndex === index }">
                                <a :href="item.url"
                                   :title="item.displayName">
                                    <div class="search__result-image-wrapper"
                                         v-if="showItemImages">
                                        <img class="search__result-image"
                                             :src="item.img"
                                             :alt="item.displayName">
                                    </div>
                                    <div class="search__result-info-wrapper">
                                        <div class="search__result-name"
                                             v-html="item.displayName">
                                        </div>
                                        <div class="search__result-price-wrapper">
                                            <span class="search__result-price">
                                                {{ item.price.price }}
                                            </span>
                                            <span v-if="item.priceRrp && item.priceRrp.value > 0 && item.priceRrp.value > item.price.value"
                                                  class="search__result-crossprice">
                                                {{ item.priceRrp.price }}
                                            </span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="search__show-all"
                             @click="search()">
                            <span class="search__show-all-inner">
                                {{ $translate("ODNaPo::NaPo.searchAll") }}
                            </span>
                        </div>
                    </div>
                    <div v-else-if="typeof currentSearchString !== 'undefined' && currentSearchString.length >= 3 && noResult"
                         class="search__no-results">
                        <div class="search__no-results-inner">
                            <svg width="135" height="96">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                     xlink:href="#svg-hanger">
                                </use>
                            </svg>
                            <span class="search__no-results-text" v-html="$translate('ODNaPo::NaPo.searchNoResult')"></span>
                        </div>
                    </div>
                </transition>
            </div>
        </template>

        <template v-if="type === 'mobile'">
            <div class="search-mobile__input-wrapper">
                <input type="search"
                       class="search-mobile__input"
                       :title="$translate('ODNaPo::ODNaPo.searchPlaceholder')"
                       @input="autocomplete($event.target.value)"
                       @keyup.enter="prepareSearch()"
                       @keyup.down="keydown()"
                       @keyup.up="keyup()"
                       @focus="setIsSearchFocused(true)"
                       @blur="setIsSearchFocused(false)"
                       :placeholder="$translate('ODNaPo::NaPo.searchPlaceholder')">
                <button class="search-mobile__button"
                        @click="search()">
                    <svg width="20" height="20">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink"
                             xlink:href="#svg-search">
                        </use>
                    </svg>
                </button>
            </div>
            <div class="search-mobile__result-wrapper js--search__result">
                <transition name="fade">
                    <div v-if="autocompleteResult.length"
                         class="search-mobile__h-100">
                        <div class="search-mobile__result-inner">
                            <div class="search__count">
                                {{ $translate("ODNaPo::NaPo.searchCount") }}&nbsp;({{ total }})
                            </div>
                            <div class="search__result-wrapper"
                                 v-for="(item, index) in autocompleteResult"
                                 :key="index"
                                 @click="selectAutocompleteItem(item)"
                                 :class="{ 'autocomplete-selected': selectedAutocompleteIndex === index }">
                                <a :href="item.url"
                                   :title="item.displayName">
                                    <div class="search__result-image-wrapper"
                                         v-if="showItemImages">
                                        <img class="search__result-image"
                                             :src="item.img"
                                             :alt="item.displayName">
                                    </div>
                                    <div class="search__result-info-wrapper">
                                        <div class="search__result-name"
                                             v-html="item.displayName"></div>
                                        <div class="search__result-price-wrapper">
                                        <span class="search__result-price">
                                            {{ item.price.price }}
                                        </span>
                                            <span v-if="item.priceRrp && item.priceRrp.value > 0 && item.priceRrp.value > item.price.value"
                                                  class="search__result-crossprice">
                                            {{ item.priceRrp.price }}
                                        </span>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <div class="search-mobile__show-all"
                             @click="search()">
                            <span class="search__show-all-inner">
                                {{ $translate("ODNaPo::NaPo.searchAll") }}
                            </span>
                        </div>
                    </div>
                    <div v-else-if="typeof currentSearchString !== 'undefined' && currentSearchString.length >= 3 && noResult"
                         class="search__no-results">
                        <div>
                            <svg width="135" height="96">
                                <use xmlns:xlink="http://www.w3.org/1999/xlink"
                                     xlink:href="#svg-hanger">
                                </use>
                            </svg>
                            <span class="search__no-results-text" v-html="$translate('ODNaPo::NaPo.searchNoResult')"></span>
                        </div>
                    </div>
                    <div v-else-if="typeof currentSearchString === 'undefined' || currentSearchString.length < 3"
                         class="search__search-please">
                        {{ $translate("ODNaPo::NaPo.searchPlease") }}
                    </div>
                </transition>
            </div>
        </template>
    </div>
</template>

<script>
    import ApiService from 'ceres/app/services/ApiService';
    import UrlService from 'ceres/app/services/UrlService';

    export default {

        props: {
            template: {
                type: String,
                default: '#vue-item-search'
            },
            showItemImages: {
                type: Boolean,
                default: true
            },
            forwardToSingleItem: {
                type: Boolean,
                default: App.config.search.forwardToSingleItem
            },
            type: {
                type: String
            },
            timeout:
                {
                    type: Number,
                    default: 200
                }
        },


        data() {
            return {
                currentSearchString: '',
                promiseCount: 0,
                autocompleteResult: [],
                selectedAutocompleteIndex: -1,
                isSearchFocused: false,
                noResult: true,
                searchString: '',
                total: 0,
                onValueChanged: null,
            };
        },


        computed: {
            selectedAutocompleteItem() {

                const selectedAutocompleteItem = this.autocompleteResult[this.selectedAutocompleteIndex];

                if (this.selectedAutocompleteIndex < 0 || !selectedAutocompleteItem) {
                    return null;
                }

                return selectedAutocompleteItem;
            },
            autocompleteTypes() {
                return this.$store.state.itemSearch.autocompleteTypes
            }
        },

        isShopBuilder()
        {
            return App.isShopBuilder;
        },

        created() {
            this.$options.template = this.template;
        },


        mounted() {
            this.$nextTick(() => {
                const urlParams = UrlService.getUrlParams(document.location.search);

                this.$store.commit('setItemListSearchString', urlParams.query);
                this.currentSearchString = urlParams.query;
            });
        },


        methods: {

            prepareSearch() {
                if (this.selectedAutocompleteItem) {

                    if (this.forwardToSingleItem) {
                        window.open(this.selectedAutocompleteItem.url, '_self', false);
                    } else {
                        this.currentSearchString = this.selectedAutocompleteItem.name;
                        this.$store.commit('setItemListSearchString', this.currentSearchString);

                        this.search();
                    }
                } else {
                    this.search();
                }

                // $('#searchBox').collapse('hide');
            },

            search() {

                if (this.currentSearchString.length) {

                    let searchBaseURL = '/search?query=';

                    if (App.defaultLanguage !== App.language) {
                        searchBaseURL = `/${App.language}/search?query=`;
                    }

                    window.open(searchBaseURL + this.currentSearchString, '_self', false);

                } else {
                    this.preventSearch = false;
                }
            },

            // updateTitle(searchString) {
            //     document.querySelector('.category__title').innerHTML = TranslationService.translate('Ceres::Template.itemSearchResults') + ' ' + encodeURIComponent(searchString);
            //     document.title = TranslationService.translate('Ceres::Template.itemSearchResults') + ' ' + encodeURIComponent(searchString) + ' | ' + App.config.header.companyName;
            // },

            autocomplete(searchString) {

                this.currentSearchString = searchString;

                if (typeof searchString !== 'undefined' && searchString.length >= 2) {
                    if (this.promiseCount >= Number.MAX_SAFE_INTEGER) {
                        this.promiseCount = 0;
                    }

                    const promiseCount = ++this.promiseCount;

                    this.noResult = false;

                    ApiService.get('/rest/napo/item/search/autocomplete', {
                        query: searchString,
                        itemsPerPage: this.getItemsPerPage()
                    }).done(response => {
                        if (this.promiseCount === promiseCount) {
                            this.total = response.total;
                            this.transformAutocomplete(response, searchString);
                        }
                    });
                } else {
                    this.autocompleteResult = [];
                }
            },

            getItemsPerPage() {

                if ($(document).outerWidth() >= 992) {
                    return 8;
                } else {
                    return 12;
                }

            },

            // transform the autocomplete result to usable object
            transformAutocomplete(data, searchString) {

                this.autocompleteResult = [];
                this.selectedAutocompleteIndex = -1;

                if (data && data.documents.length) {
                    for (const item of data.documents) {

                        const url    = this.$options.filters.itemURL(item.data);
                        const name   = this.$options.filters.itemName(item.data);

                        let displayName = name;
                        let price       = false;
                        let priceRrp    = false;

                        //sometimes urlPreview sometimes urlMiddle (plenty)
                        let images = this.$options.filters.itemImages(item.data.images, 'urlPreview');
                        let img    = this.$options.filters.itemImage(images);

                        if(typeof img === 'undefined') {
                            images = this.$options.filters.itemImages(item.data.images, 'urlMiddle');
                            img    = this.$options.filters.itemImage(images);
                        }

                        //if search returns middle replace with preview
                        if(typeof img === 'string') {
                            img = img.replace('/middle/', '/preview/');
                        }

                        for (const key in item.data.prices) {
                            if (item.data.prices.hasOwnProperty(key) && item.data.prices[key]) {

                                const prices = item.data.prices[key];

                                if (key === 'default') {

                                    price = {};

                                    price.price = prices.price.formatted;
                                    price.value = prices.price.value;
                                }

                                if (key === 'rrp') {

                                    priceRrp = {};

                                    priceRrp.price = prices.price.formatted;
                                    priceRrp.value = prices.price.value;
                                }
                            }
                        }

                        for (const split of searchString.split(' ')) {
                            displayName = displayName.replace(split, `<strong>${split}</strong>`);
                        }

                        this.autocompleteResult.push({
                            img,
                            url,
                            name,
                            displayName,
                            price,
                            priceRrp
                        });
                    }
                } else {
                    this.noResult = true;
                }
            },

            selectAutocompleteItem(item) {

                if (this.forwardToSingleItem) {
                    window.open(item.url, '_self', false);
                } else {

                    this.currentSearchString = item.name;
                    this.$store.commit('setItemListSearchString', this.currentSearchString);

                    this.search();
                }
            },

            keyup() {

                this.selectedAutocompleteIndex--;

                if (this.selectedAutocompleteIndex < 0) {
                    this.selectedAutocompleteIndex = 0;
                }
            },

            keydown() {

                this.selectedAutocompleteIndex++;

                if (this.selectedAutocompleteIndex > this.autocompleteResult.length - 1) {
                    this.selectedAutocompleteIndex = this.autocompleteResult.length - 1;
                }
            },

            // hide autocomplete after 100ms to make clicking on it possible
            setIsSearchFocused(value) {

                let that = this;

                setTimeout(() => {

                    that.isSearchFocused = !!value;

                    if (that.isSearchFocused) {

                        $('.js--search__result').slideDown(300);
                        $('.mobile-navigation__close').fadeOut(150);
                        setTimeout(function () {
                            $('.mobile-navigation__close-search').fadeIn(150);
                        }, 150);

                        that.autocomplete(that.currentSearchString);

                    } else if (!that.isSearchFocused && that.noResult) {

                        $('.js--search__result').slideUp(300);
                        $('.mobile-navigation__close-search').fadeOut(150);
                        setTimeout(function () {
                            $('.mobile-navigation__close').fadeIn(150);
                        }, 300);
                    }

                }, 100);
            }
        }
    }
</script>
